module.exports = __webpack_public_path__ + "img/IMG_1401_L_Black_MockedUp.640fcfd0.jpg";